module.exports = __webpack_public_path__ + "static/media/kaarina-logo.187a7252.png";